import portalApi from './portalApi';

const portalTaskService = {
  getTasks: () => portalApi.get('/portal/tasks'),
};

export default portalTaskService;
